export default __webpack_public_path__ + "static/media/bg-dark-brown.a4180fc0.jpg";